var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangetick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.29193C0 6.09277 0.873611 3.98369 2.42865 2.42865C3.98369 0.873611 6.09277 0 8.29193 0C10.4911 0 12.6002 0.873611 14.1552 2.42865C15.7102 3.98369 16.5839 6.09277 16.5839 8.29193C16.5839 10.4911 15.7102 12.6002 14.1552 14.1552C12.6002 15.7102 10.4911 16.5839 8.29193 16.5839C6.09277 16.5839 3.98369 15.7102 2.42865 14.1552C0.873611 12.6002 0 10.4911 0 8.29193H0ZM7.81873 11.8409L12.5927 5.87289L11.7303 5.18301L7.65953 10.2698L4.77615 7.86738L4.06857 8.71647L7.81873 11.842V11.8409Z",
    fill: "#FB5850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangetick);
export default __webpack_public_path__ + "static/media/orangetick.8e8d179eca877f2c49c7cee103976661.svg";
export { ForwardRef as ReactComponent };